<template>
    <div class="new-input-box">
        <jd-title label='分享设置' type="bold"></jd-title>
        <el-form-item label="小程序分享标题:" required width="125">
            <el-input type="text" style="width: 425px;" :disabled="isDisabled" show-word-limit v-model="ruleFormData.shareTitle"
                :maxlength="28" @input="inp"></el-input>
        </el-form-item>
        <el-form-item label="小程序分享简介:" required width="125">
            <el-input type="text" style="width: 425px;" :disabled="isDisabled" show-word-limit
                v-model="ruleFormData.shareIntroduce" :maxlength="28" @input="inp"></el-input>
        </el-form-item>
        <el-form-item label="小程序分享图片:" required width="130">
            <div class="miniAppPic">
                <div class="top" v-if="!isDisabled">
                    <el-upload class="upload" action="/jd-hd-web/image/upload" :show-file-list="false"
                        :before-upload="beforeUpload1" :on-success="handleUpload1">
                        <jd-button type="blueText">自定义上传</jd-button>
                    </el-upload>
                    <jd-button type="blueText" style="margin-left: 8px" @click="picUrlReset1">重置</jd-button>
                </div>
                <div class="bottom">
                    <el-image class="elImg" :src="ruleFormData.sharePic" fit="contain">
                        <div slot="error" class="image-slot">
                            <i class="el-icon-plus"></i>
                        </div>
                    </el-image>
                    <div class="tips1" v-if="!isDisabled">
                        <p>建议上传尺寸：200px * 200px</p>
                        <p>图片大小：1MB以内</p>
                        <p>格式：jpg、png</p>
                    </div>
                </div>
            </div>
        </el-form-item>
    </div>
</template>
<script>
export default {
    components: {},
    model: {
        prop: "ruleForm",
        event: "ruleFormUpdate",
    },
    props: {
        sharePic: {
            type: String,
            default: "",
        },
        ruleForm:{
            type: Object,
            default: {},
        },
        isDisabled: {
            type: Boolean,
            default: false,
        },
    },
    watch: {},
    data() {
        return {
            uploadSize: '',
        }
    },
    computed: {
        ruleFormData: {
            get: function () {
                return this.ruleForm;
            },
            set: function (val) {
                this.$emit("ruleFormUpdate", val);
            },
        },
    },
    created() { },
    mounted() { },
    methods: {
        inp(val) {
            this.$forceUpdate()
        },
        //上传图片前校验   分享设置
        beforeUpload1(file) {
            let _this = this
            let image = new Image()
            let _URL = window.URL || window.webkitURL
            image.onload = function () {
                const valid = (image.width == 200 && image.height == 200)
                file.isFlag = valid
                _this.uploadSize = valid
                console.log(valid);
                if (valid) {
                } else {
                    _this.$message.info('图片宽高不符合要求,请重新上传')
                    sizetype = false
                    return false
                }
            }
            image.src = _URL.createObjectURL(file)
            console.log(file);
            const isLt3M = file.size < 1024 * 1024;

            let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
            let sorts = [".png", ".jpg"]
            let sizetype = false
            if (!isLt3M) {
                this.$message.info("上传图片大小不能超过 1MB");
                return false
            }
            if (sorts.indexOf(type) < 0) {
                this.$message.info("所选文件格式不符，请重新选择");
                return false;
            }
        },
        // 上传成功  分享设置
        handleUpload1(res) {
            if (res.code != 1) {
                this.$message.error(res.message);
            } else {
                console.log(this.uploadSize);
                if (this.uploadSize) {
                    this.ruleFormData.sharePic = res.data;
                    this.$forceUpdate()
                }
            }
        },
        // 重置背景图  分享设置
        picUrlReset1() {
            this.ruleFormData.sharePic = this.sharePic
            this.$forceUpdate()
        },
    }
}
</script>
<style lang="scss" scoped>
.miniAppPic {
    position: relative;

    .image-slot {
        width: 100%;
        height: 100%;
        background: #f5f7fa;
        text-align: center;
        padding-top: 43px;

        i {
            font-size: 30px;
            color: #909399;
        }
    }

    .top {
        position: relative;
        left: 8px;
        display: flex;

        .returnBtn {
            border-radius: 4px;
            width: auto;
            height: 32px;
            line-height: 32px;
            text-align: center;
            color: #fe4d45;
            background: rgba(254, 77, 69, 0.1);
            border: 1px solid #fe4d45;

            &:hover {
                color: #fff;
                background: #fe4d45;
            }
        }

        .reset {
            color: #fe4d45;
            cursor: pointer;
            font-size: 14px;
            margin-left: 15px;
        }
    }

    .bottom {
        position: relative;
        top: 15px;
        // margin-left: 100px;

        .elImg {
            width: 120px;
            height: 120px;
            border: 1px dashed #dddddd;
            border-radius: 5px;
        }

        .tips1 {
            position: absolute;
            left: 135px;
            top: 22px;
            line-height: 2;
            color: #aaaaaa;
            font-size: 13px;
        }
    }
}
</style>